module.exports = __webpack_public_path__ + "static/step4-f0dfaf9a97fdc082f9f029c8dc148b1e.png";